"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_chartjs_2_1 = require("react-chartjs-2");
const chart_js_1 = require("chart.js");
chart_js_1.Chart.register(chart_js_1.ArcElement, chart_js_1.Tooltip, chart_js_1.Legend);
//
// styles
//
const StyledChartContainer_1 = require("../StyledChartContainer");
const PieChart = (props) => {
    const labelSpacing = '        ';
    const data = {
        labels: [
            `${props.labels[0]} (${props.percents[0]}%)${labelSpacing}`,
            `${props.labels[1]} (${props.percents[1]}%)${labelSpacing}`,
            `${props.labels[2]} (${props.percents[2]}%)${labelSpacing}`
        ],
        datasets: [
            {
                data: props.percents,
                backgroundColor: ['#5A1CF4', '#FFBEA0', '#E72D4D']
            }
        ]
    };
    const doughnutOptions = {
        radius: '75%',
        cutout: '85%',
        events: ['mousemove'],
        plugins: {
            tooltip: {
                callbacks: {
                    title: function (context) {
                        return `${props.labels[context[0].dataIndex]}`;
                    },
                    label: function (context) {
                        return `${props.values[context.dataIndex]} (${context.parsed}%)`;
                    }
                },
                backgroundColor: '#ffffff',
                bodyAlign: 'center',
                bodyColor: '#6E84A3',
                borderColor: '#EDF2F9',
                borderWidth: 1,
                padding: 20,
                position: 'nearest',
                titleAlign: 'center',
                titleColor: '#000000',
                titleFont: {
                    size: 15,
                    family: "'Cerebri Sans',sans-serif"
                }
            },
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    font: {
                        size: 13,
                        family: "'Cerebri Sans',sans-serif"
                    },
                    boxWidth: 7,
                    padding: 5,
                    usePointStyle: true
                }
            }
        },
        spacing: 3
    };
    return (react_1.default.createElement(StyledChartContainer_1.StyledChartContainer, null,
        react_1.default.createElement(react_chartjs_2_1.Doughnut, { data: data, options: doughnutOptions })));
};
PieChart.propTypes = {
    labels: prop_types_1.default.arrayOf(prop_types_1.default.string),
    percents: prop_types_1.default.arrayOf(prop_types_1.default.number),
    values: prop_types_1.default.arrayOf(prop_types_1.default.number)
};
exports.default = (0, react_1.memo)(PieChart, (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps));
